import type { RoleConfig } from '../types.js';

export const werewolf: RoleConfig = {
  id: 'werewolf',
  faction: 'solo',
  title: { ru: 'Оборотень', uk: 'Перевертень' },
  latin: 'WEREWOLF',
  number: '26',
  accent: '#a8a3ff',
  ability: {
    ru: 'В нечётные ночи (полная луна) устраивает резню: убивает цель и всех, кто её этой ночью посетил. Побеждает в одиночку.',
    uk: 'У непарні ночі (повний місяць) влаштовує різанину: вбиває ціль та всіх, хто її цієї ночі відвідав. Перемагає на самоті.',
  },
  abilities: [
    { key: 'rampage', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  nightFilter: 'odd',
  victory: { type: 'solo-last-standing' },
};
